import { css } from "emotion";

export const threadContainerStyles = css({
  display: "flex",
  flexDirection: "column",
  flexGrow: 1,
  maxHeight: "100%",
  overflowY: "auto"
});
